export default "skymp5-front/30e202ab1d49067df23dc86b5f806072.png";